const apiFormDataRequest = (token, path, method, body) => {
	let config = {
		method,
		headers: {
			Authorization: 'Bearer ' + token
		},
		body
	}

	return fetch(process.env.REACT_APP_DEV_PLATFORM_URL + path, config)
}

export default apiFormDataRequest



// WEBPACK FOOTER //
// /opt/build/repo/packages/utils/apiFormDataRequest.js